<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-documents">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-file"></i>
                                    <span>Documente atașate</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="p-2 d-flex justify-content-end">
                        <button class="btn btn-sm" [ngClass]="showUploadPanel ? 'btn-warning' : 'btn-primary'"
                            (click)="toggleUploadPanel()">
                            <i class="fa-solid" [ngClass]="showUploadPanel ? 'fa-times' : 'fa-plus'"></i>
                            {{ showUploadPanel ? 'Anulează' : 'Adaugă Document' }}
                        </button>
                    </div>

                    <mat-divider></mat-divider>

                    <!-- ── LIST VIEW ─────────────────────────────────────────────── -->
                    <ng-container *ngIf="!showUploadPanel">
                        <div class="p-2 d-flex flex-column gap-2 mb-3">

                            <!-- Category pills -->
                            <div class="d-flex flex-wrap gap-2">
                                <button class="category-pill" [class.active]="activeCategory === null"
                                    (click)="filterByCategory(null)">
                                    <i class="fa-solid fa-layer-group"></i> Toate
                                </button>
                                <button *ngFor="let cat of documentCategories" class="category-pill"
                                    [class.active]="activeCategory === cat.slug" (click)="filterByCategory(cat.slug)">
                                    <i [ngClass]="ContractDocCategoryIcons[cat.slug]"></i>
                                    {{ cat.name }}
                                </button>
                            </div>

                            <!-- View / order toggles -->
                            <div class="d-flex justify-content-start gap-2">
                                <div class="view-toggle">
                                    <button [class.active]="currentView === ViewMode.BY_CATEGORY"
                                        (click)="setViewMode(ViewMode.BY_CATEGORY)" matTooltip="Pe categorii">
                                        <i class="fa-solid fa-folder"></i>
                                    </button>
                                    <button [class.active]="currentView === ViewMode.BY_DATE"
                                        (click)="setViewMode(ViewMode.BY_DATE)" matTooltip="Cronologic">
                                        <i class="fa-solid fa-clock-rotate-left"></i>
                                    </button>
                                    <button [class.active]="currentView === ViewMode.BY_TAG"
                                        (click)="setViewMode(ViewMode.BY_TAG)" matTooltip="Tag">
                                        <i class="fa-solid fa-tags"></i>
                                    </button>
                                </div>
                                <div class="view-toggle">
                                    <button [class.active]="currentOrder === OrderMode.DESCENDING"
                                        (click)="setOrder(OrderMode.DESCENDING)" matTooltip="Descrescător">
                                        <i class="fa-solid fa-arrow-down"></i>
                                    </button>
                                    <button [class.active]="currentOrder === OrderMode.ASCENDING"
                                        (click)="setOrder(OrderMode.ASCENDING)" matTooltip="Crescător">
                                        <i class="fa-solid fa-arrow-up"></i>
                                    </button>
                                </div>
                            </div>

                            <mat-divider class="my-2"></mat-divider>

                            <!-- Cards -->
                            <div class="ms-2 text-center" *ngIf="!viewCards.length">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </div>
                            <div class="ms-2" *ngFor="let card of viewCards">
                                <div class="mb-2">
                                    <span *ngIf="card.icon">
                                        <i class="fa-solid" [ngClass]="card.icon"></i>&nbsp;{{ card.label }}
                                    </span>
                                    <div *ngIf="card.color" class="px-2 py-1 rounded d-inline-block"
                                        [style.backgroundColor]="card.color">
                                        <span style="color:#ffffff; font-size:14px;">{{ card.label }}</span>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                                <div class="py-2 d-flex flex-row gap-2 flex-wrap">
                                    <div *ngFor="let group of card.fileGroups" style="max-width:400px;"
                                        class="border border-primary-subtle border-2 rounded p-2 d-flex flex-column gap-2">
                                        <span><strong>Categorie:</strong> {{ group.category_name }}</span>
                                        <span><strong>Dată creat:</strong> {{ group.created_at | date:'dd.MM.yyyy':'ro'
                                            }}</span>
                                        <span *ngIf="group.document_nr"><strong>Număr document:</strong> {{
                                            group.document_nr }}</span>
                                        <span *ngIf="group.document_date"><strong>Dată document:</strong> {{
                                            group.document_date | date:'dd.MM.yyyy':'ro' }}</span>
                                        <span><strong>Tag-uri:</strong></span>
                                        <div *ngIf="group.tags.length" class="d-flex flex-wrap gap-2">
                                            <div *ngFor="let tag of group.tags"
                                                class="d-flex align-items-center gap-1 px-2 py-1 rounded"
                                                [style.backgroundColor]="tag.color">
                                                <span style="color:#ffffff; font-size:14px;">{{ tag.name }}</span>
                                            </div>
                                        </div>
                                        <span><strong>Documente încărcate:</strong></span>
                                        <div class="d-flex flex-row flex-wrap gap-2">
                                            <button *ngFor="let file of group.files" type="button"
                                                class="btn btn-outline-primary btn-sm" (click)="downloadFile(file.id)">
                                                <i class="fa-solid fa-download"></i>
                                                {{ file.original_name }}
                                            </button>
                                        </div>
                                        <div class="d-flex justify-content-end gap-2 flex-wrap">
                                            <button type="button" class="btn btn-info btn-sm"
                                                (click)="viewDocument(group)">
                                                Vizualizare
                                            </button>
                                            <button type="button" class="btn btn-warning btn-sm"
                                                (click)="openEditPanel(group)">
                                                Editare
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <!-- ── UPLOAD / EDIT PANEL ───────────────────────────────────── -->
                    <ng-container *ngIf="showUploadPanel">
                        <div class="p-2 d-flex flex-column">
                            <div class="d-flex flex-row flex-wrap justify-content-between align-items-start mb-2">
                                <h4 class="m-0">{{ editData ? 'Editare Document' : 'Încărcare Document' }}</h4>
                                <button class="btn btn-sm btn-success" (click)="addTagToNomenclator()">
                                    <i class="fa-solid fa-plus"></i> Adaugă Tag
                                </button>
                            </div>

                            <form [formGroup]="form">
                                <!-- Row 1: Categorie + Tag -->
                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Dosar (Categorie)</mat-label>
                                            <mat-select formControlName="category_id"
                                                (selectionChange)="onCategoryChange($event.value)">
                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let cat of documentCategories" [value]="cat.id">
                                                    {{ cat.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="form.controls['category_id'].invalid && form.controls['category_id'].touched">
                                                Selectați o opțiune
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Tag Document</mat-label>
                                            <mat-select formControlName="tag_id" (selectionChange)="addTagInArray()"
                                                (openedChange)="onDocumentTagsClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="documentTagsControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>
                                                <mat-option *ngIf="filteredDocumentTags.length === 0" disabled>
                                                    Nu au fost găsite rezultate
                                                </mat-option>
                                                <mat-option *ngFor="let t of filteredDocumentTags" [value]="t.id">
                                                    {{ t.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Tag chips -->
                                <div *ngIf="!tagArr.length" class="mb-3">
                                    <mat-error>Adăugați minim un tag</mat-error>
                                </div>
                                <div *ngIf="tagArr.length" class="mb-3 d-flex flex-wrap gap-2">
                                    <div *ngFor="let tag of tagArr; let i=index"
                                        class="d-flex align-items-center gap-1 px-2 py-1 rounded"
                                        [style.backgroundColor]="tag.color">
                                        <span style="color:#ffffff; font-size:14px;">{{ tag.name }}</span>
                                        <mat-icon
                                            style="font-size:16px; width:16px; height:16px; color:#fff; cursor:pointer;"
                                            (click)="removeTagInArray(i)">cancel</mat-icon>
                                    </div>
                                </div>

                                <!-- Row 2: Nr. document + Dată document -->
                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Număr document</mat-label>
                                            <input type="text" matInput formControlName="document_nr" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Dată document</mat-label>
                                            <input matInput [matDatepicker]="documentDatePicker"
                                                formControlName="document_date" readonly
                                                (focus)="documentDatePicker.open()" />
                                            <mat-hint>ZZ/LL/AAAA</mat-hint>
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="documentDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #documentDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- Observații -->
                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Observații</mat-label>
                                            <textarea matInput formControlName="observations"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </form>

                            <!-- ── File upload ─────────────────────────────────────────── -->
                            <form [formGroup]="filesForm">
                                <div class="solicitare-card__upload">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Fotografii / Documente</p>
                                        <button class="upload-btn" (click)="fileInputDocumentFiles.click()"
                                            type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon>&nbsp;ÎNCARCĂ
                                        </button>
                                    </div>
                                    <div class="solicitare-card__upload-files"
                                        *ngIf="filesForm.value.files?.length > 0 && !uploading">
                                        <div class="solicitare-card__upload-file"
                                            *ngFor="let f of filesForm.value.files; let i=index">
                                            <span class="solicitare-card__upload-file-name">
                                                {{ f.original_name.length > 30 ? (f.original_name | slice:0:30) + '..' :
                                                f.original_name }}
                                            </span>
                                            <div class="d-flex gap-4 align-items-center">
                                                <button class="solicitare-card__upload-file-view" type="button"
                                                    matTooltip="Vizualizează fișierul" (click)="downloadTempFile(f)">
                                                    <mat-icon class="btn-icon">visibility</mat-icon>
                                                    <span class="btn-text">Vizualizează</span>
                                                </button>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul" (click)="removeFile(i)">
                                                    <img class="btn-img" src="../../../assets/icons/delete.svg"
                                                        alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-spinner diameter="32" style="margin-right:8px; margin-top:4px"
                                        *ngIf="uploading"></mat-spinner>
                                    <input type="file"
                                        accept=".png,.jpg,.jpeg,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ods,.odt"
                                        #fileInputDocumentFiles name="fileInputDocumentFiles" (change)="addFile($event)"
                                        multiple style="display:none" />
                                </div>
                            </form>

                            <!-- Previously uploaded files (edit mode) -->
                            <ng-container *ngIf="editData && uploadedFiles.length">
                                <h4 class="my-2">Documente încărcate anterior</h4>
                                <div class="d-flex flex-row flex-wrap gap-3">
                                    <div *ngFor="let file of uploadedFiles; let i=index" class="position-relative">
                                        <button type="button" class="btn btn-outline-primary btn-sm"
                                            (click)="downloadFile(file.id)">
                                            <i class="fa-solid fa-download"></i> {{ file.original_name }}
                                        </button>
                                        <button type="button"
                                            class="btn btn-small btn-danger p-1 small-absolute-btn d-flex"
                                            (click)="deleteFile(i)" title="Șterge">
                                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="editData && deletedFiles.length">
                                <h4 class="my-2">Documente pregătite pentru ștergere</h4>
                                <div class="d-flex flex-row flex-wrap gap-3">
                                    <div *ngFor="let file of deletedFiles; let i=index" class="position-relative">
                                        <button type="button" class="btn btn-outline-primary btn-sm"
                                            (click)="downloadFile(file.id)">
                                            <i class="fa-solid fa-download"></i> {{ file.original_name }}
                                        </button>
                                        <button type="button"
                                            class="btn btn-small btn-warning p-1 small-absolute-btn d-flex"
                                            (click)="restoreFile(i)" title="Anulează">
                                            <i class="fa-solid fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>

                            <div *ngIf="filesForm.invalid && !uploadedFiles.length" class="mt-2">
                                <mat-error>Adăugați minim un document</mat-error>
                            </div>

                            <mat-divider class="my-3"></mat-divider>

                            <!-- Submit -->
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-secondary" type="button" (click)="toggleUploadPanel()">
                                    Anulează
                                </button>
                                <button class="btn btn-primary" type="button" (click)="submitUpload()" [disabled]="form.invalid ||
                                                !tagArr.length ||
                                                (!editData && filesForm.invalid) ||
                                                (editData && filesForm.invalid && !uploadedFiles.length)">
                                    <i class="fa-solid fa-check"></i>
                                    {{ editData ? 'Editează Document' : 'Salvează Document' }}
                                </button>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</div>